var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import { isEqual } from "underscore";
import TocStockHeader from "../TocHeader/TocStockHeader";
import SingleHeadingText from "../TocHeader/SingleHeadingText";
import OrderConfirmation from "@frameworks/web/components/generic/TOCgeneric/OrderConfirmation";
import BuySellBtn from "../Stock/BuySellBtn";
import MarginShortFunds from "../Stock/MarginShortFunds";
import OrderMsg from "@frameworks/web/components/generic/OrderMsg/OrderMsg";
import StockQuote from "../TocHeader/StockQuote";
import di from "@frameworks/web/components/features/TOC/di/servicelocator";
import { TOCBUYORSELL } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
import Common_Shimmer from "@frameworks/shared-library/components/common_shimmer";
import { eqOrder, eqProducts } from "../../Equity/EqConstants";
import ChartiqBtmDrawer from "@frameworks/web/components/generic/ChartiqBtmDrawer";
import { useNavigate, useLocation } from "react-router-dom";
import { ITOCScreenStateEnum, checkTocState, getProductValues, exchangesData, } from "../../constant";
import { useSelector } from "react-redux";
import { CommodityOrderBookTabs, EOrderBookTabs, EorderBookButtonsList, OrderbookTocStateEnum, } from "@frameworks/web/components/features/OrderBook/constant";
import * as moment from "moment";
import { addCommasWithoutDecimal } from "@domains/utils/numberMethods";
import ThreeDotLoader from "@frameworks/web/components/generic/ThreeDotLoader";
import * as URLConfig from "@frameworks/web/config/domain";
import { openFundTransferTab } from "@domains/utils/fundTransfer";
import PIT_IRF from "../PTRIRF/PITIRF";
import { EExchangeType } from "@domains/features/Markets/Equity/entities/iTopGainersLosers";
import { reportsRoutePaths, EReportRoutes, } from "@frameworks/web/components/constant";
var config = URLConfig.config;
var OrderConfirmationMain = function (props) {
    var device = DeviceContext();
    var navigate = useNavigate();
    var location = useLocation();
    var _a = __read(useState(ITOCScreenStateEnum.ORDER_CONFIRM), 2), screenState = _a[0], setScreenState = _a[1];
    var _b = __read(useState(false), 2), isSuccessRes = _b[0], setIsSuccessRes = _b[1];
    var _c = __read(React.useState(false), 2), sipsuccess = _c[0], setSipsuccess = _c[1];
    var multiQuote = useSelector(function (state) { return state.TOCJourney.multiQuoteReducers; }
    //isEqual
    ).multiQuote;
    var checkMarginData = useSelector(function (state) { return state.TOCJourney.checkMargin; }, isEqual).data;
    var _d = useSelector(function (state) { return state.accountDetailsReducer; }, isEqual), userID = _d.userID, empOrDependent = _d.empOrDependent, productsAlias = _d.productsAlias;
    var _e = __read(useState({
        empOrDependent: false,
        expandedVisual: false,
    }), 2), pitrifCheck = _e[0], setPitrifCheck = _e[1];
    useEffect(function () {
        return function () {
            // Anything in here is fired on component unmount.
            di.tocJourney.flushPlaceOrderError();
            di.tocJourney.flushPlaceOrderData();
        };
    }, []);
    var _f = useSelector(function (state) { return state.TOCJourney.placeNormalTrade; }, isEqual), placeNormalTrade = _f.data, placeNormalTradeLoader = _f.loader, placeNormalTradeError = _f.errorData;
    var _g = useSelector(function (state) { return state.TOCJourney.orderDetails; }, isEqual), orderDetails = _g.data, orderDetailsLoader = _g.loader, orderDetailsError = _g.errorData;
    var onCompUnmount = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setScreenState(ITOCScreenStateEnum.ORDER_CONFIRM);
            props.setConfirmOrder(false);
            return [2 /*return*/];
        });
    }); };
    var placeReOrder = function (failedShrsQty) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var payloadNormal = {
            userID: userID,
            body: {
                trdSym: (_a = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.tradeSymbol,
                exc: props.exchange,
                action: props.action.toUpperCase(),
                sym: (_b = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _b === void 0 ? void 0 : _b.symbol,
                dur: (_c = props === null || props === void 0 ? void 0 : props.activeButton) === null || _c === void 0 ? void 0 : _c.VALIDITY,
                ordTyp: ((_d = props === null || props === void 0 ? void 0 : props.activeButton) === null || _d === void 0 ? void 0 : _d.ORDER) === "SL"
                    ? "STOP_LIMIT"
                    : (_e = props === null || props === void 0 ? void 0 : props.activeButton) === null || _e === void 0 ? void 0 : _e.ORDER,
                qty: failedShrsQty,
                dscQty: (_f = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _f === void 0 ? void 0 : _f.disclosedQuantity,
                lmPrc: ((_g = props === null || props === void 0 ? void 0 : props.activeButton) === null || _g === void 0 ? void 0 : _g.ORDER) == eqOrder[0].value
                    ? ""
                    : (_h = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _h === void 0 ? void 0 : _h.limitPrice,
                trgPrc: (_j = props.tradeValues) === null || _j === void 0 ? void 0 : _j.triggerPrice,
                prdCode: getProductValues(props === null || props === void 0 ? void 0 : props.buttonList, (_k = props === null || props === void 0 ? void 0 : props.activeButton) === null || _k === void 0 ? void 0 : _k.PRODUCT) ||
                    ((_l = props === null || props === void 0 ? void 0 : props.activeButton) === null || _l === void 0 ? void 0 : _l.PRODUCT),
                ordSrc: "TOC",
                empOrDependent: empOrDependent,
            },
        };
        di.tocJourney.placeNormalTrade(payloadNormal);
    };
    var placeOrder = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42;
        var payloadNormal = {
            userID: userID,
            body: {
                trdSym: (_a = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.tradeSymbol,
                exc: props.exchange,
                action: props.action.toUpperCase(),
                sym: (_b = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _b === void 0 ? void 0 : _b.symbol,
                dur: (_c = props === null || props === void 0 ? void 0 : props.activeButton) === null || _c === void 0 ? void 0 : _c.VALIDITY,
                ordTyp: ((_d = props === null || props === void 0 ? void 0 : props.activeButton) === null || _d === void 0 ? void 0 : _d.ORDER) === "SL"
                    ? "STOP_LIMIT"
                    : (_e = props === null || props === void 0 ? void 0 : props.activeButton) === null || _e === void 0 ? void 0 : _e.ORDER,
                qty: (_f = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _f === void 0 ? void 0 : _f.quantity,
                dscQty: (_g = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _g === void 0 ? void 0 : _g.disclosedQuantity,
                lmPrc: ((_h = props === null || props === void 0 ? void 0 : props.activeButton) === null || _h === void 0 ? void 0 : _h.ORDER) == eqOrder[0].value
                    ? ""
                    : (_j = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _j === void 0 ? void 0 : _j.limitPrice,
                trgPrc: (_k = props.tradeValues) === null || _k === void 0 ? void 0 : _k.triggerPrice,
                prdCode: getProductValues(props === null || props === void 0 ? void 0 : props.buttonList, (_l = props === null || props === void 0 ? void 0 : props.activeButton) === null || _l === void 0 ? void 0 : _l.PRODUCT) ||
                    ((_m = props === null || props === void 0 ? void 0 : props.activeButton) === null || _m === void 0 ? void 0 : _m.PRODUCT),
                ordSrc: "TOC",
                empOrDependent: empOrDependent,
            },
        };
        var payloadCO = {
            userID: userID,
            body: {
                sym: (_o = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _o === void 0 ? void 0 : _o.symbol,
                dur: (_p = props === null || props === void 0 ? void 0 : props.activeButton) === null || _p === void 0 ? void 0 : _p.VALIDITY.toUpperCase(),
                lmPrc: ((_q = props === null || props === void 0 ? void 0 : props.activeButton) === null || _q === void 0 ? void 0 : _q.ORDER) == eqOrder[0].value
                    ? ""
                    : (_r = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _r === void 0 ? void 0 : _r.limitPrice,
                ordTyp: ((_s = props === null || props === void 0 ? void 0 : props.activeButton) === null || _s === void 0 ? void 0 : _s.ORDER) === "SL"
                    ? "STOP_LIMIT"
                    : (_t = props === null || props === void 0 ? void 0 : props.activeButton) === null || _t === void 0 ? void 0 : _t.ORDER,
                action: props.action.toUpperCase(),
                prdCode: getProductValues(props === null || props === void 0 ? void 0 : props.buttonList, (_u = props === null || props === void 0 ? void 0 : props.activeButton) === null || _u === void 0 ? void 0 : _u.PRODUCT) ||
                    ((_v = props === null || props === void 0 ? void 0 : props.activeButton) === null || _v === void 0 ? void 0 : _v.PRODUCT),
                exc: props.exchange,
                qty: props.exchange === "MCX"
                    ? (_w = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _w === void 0 ? void 0 : _w.noOfLots
                    : (_x = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _x === void 0 ? void 0 : _x.quantity,
                trdSym: (_y = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _y === void 0 ? void 0 : _y.tradeSymbol,
                dsQty: props.exchange === "MCX"
                    ? (_z = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _z === void 0 ? void 0 : _z.disclosedQuantity
                    : (Number((_0 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _0 === void 0 ? void 0 : _0.disclosedQuantity) *
                        (Number((_1 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _1 === void 0 ? void 0 : _1.quantity) /
                            Number((_2 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _2 === void 0 ? void 0 : _2.noOfLots))).toString(),
                trgPrc: (_3 = props.tradeValues) === null || _3 === void 0 ? void 0 : _3.triggerPrice,
                ordSrc: "TOC",
                locInd: "WEB",
                vlDt: "",
                empOrDependent: empOrDependent,
            },
        };
        var payloadAMO = {
            amoBody: {
                trdSym: (_4 = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _4 === void 0 ? void 0 : _4.tradeSymbol,
                exc: props.exchange,
                action: props.action.toUpperCase(),
                dur: (_5 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _5 === void 0 ? void 0 : _5.VALIDITY.toUpperCase(),
                qty: (_6 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _6 === void 0 ? void 0 : _6.quantity,
                // dscQty: props?.tradeValues?.disclosedQuantity,
                lmPrc: ((_7 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _7 === void 0 ? void 0 : _7.ORDER) == eqOrder[0].value
                    ? ""
                    : (_8 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _8 === void 0 ? void 0 : _8.limitPrice,
                trgPrc: (_9 = props.tradeValues) === null || _9 === void 0 ? void 0 : _9.triggerPrice,
                prdCode: getProductValues(props === null || props === void 0 ? void 0 : props.buttonList, (_10 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _10 === void 0 ? void 0 : _10.PRODUCT) ||
                    ((_11 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _11 === void 0 ? void 0 : _11.PRODUCT),
                ordSrc: "TOC",
                ordTyp: ((_12 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _12 === void 0 ? void 0 : _12.ORDER) === "SL"
                    ? "STOP_LIMIT"
                    : (_13 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _13 === void 0 ? void 0 : _13.ORDER,
                sym: (_14 = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _14 === void 0 ? void 0 : _14.symbol,
                empOrDependent: empOrDependent,
            },
            userID: userID,
        };
        var payloadEsip = {
            EsipBody: {
                trdSym: (_15 = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _15 === void 0 ? void 0 : _15.tradeSymbol,
                exc: props.exchange,
                trTyp: TOCBUYORSELL.SIP,
                inv: (props === null || props === void 0 ? void 0 : props.showAmount) ? "Amount" : "Quantity",
                val: (props === null || props === void 0 ? void 0 : props.showAmount)
                    ? (_16 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _16 === void 0 ? void 0 : _16.amount
                    : (_17 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _17 === void 0 ? void 0 : _17.quantity,
                freq: (_18 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _18 === void 0 ? void 0 : _18.FREQUENCY,
                brid: "BOMBAY",
                brk: "EBL_CAS",
                tnr: +((_19 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _19 === void 0 ? void 0 : _19.totalperiod),
                stDt: moment(props === null || props === void 0 ? void 0 : props.tradeValues.startDate).format("DD-MM-YYYY"),
                prCd: getProductValues(props === null || props === void 0 ? void 0 : props.buttonList, (_20 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _20 === void 0 ? void 0 : _20.PRODUCT) ||
                    ((_21 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _21 === void 0 ? void 0 : _21.PRODUCT),
            },
            userID: userID,
        };
        var payloadBO = {
            userID: userID,
            bracketTradeBody: {
                exc: props === null || props === void 0 ? void 0 : props.exchange,
                sym: (_22 = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _22 === void 0 ? void 0 : _22.symbol,
                trnsTyp: (_23 = props === null || props === void 0 ? void 0 : props.action) === null || _23 === void 0 ? void 0 : _23.toUpperCase(),
                qty: (_24 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _24 === void 0 ? void 0 : _24.quantity,
                dur: (_25 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _25 === void 0 ? void 0 : _25.VALIDITY,
                prc: (_26 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _26 === void 0 ? void 0 : _26.limitPrice,
                sqOffVal: (_27 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _27 === void 0 ? void 0 : _27.target,
                slVal: (_28 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _28 === void 0 ? void 0 : _28.stopLoss,
                trlSl: "N",
                trlSlVal: null,
                ordSrc: "TOC",
                trdBsdOn: "LTP",
                sqOffBsdOn: "Absolute",
                slBsdOn: "Absolute",
                empOrDependent: empOrDependent,
            },
        };
        if ((_29 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _29 === void 0 ? void 0 : _29.disclosedQuantity)
            payloadBO = __assign(__assign({}, payloadBO), { bracketTradeBody: __assign(__assign({}, payloadBO.bracketTradeBody), { dsQty: (_30 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _30 === void 0 ? void 0 : _30.disclosedQuantity }) });
        if (props.exchange === "OFS") {
            var payloadOFS = {
                userID: userID,
                body: {
                    issueId: (_31 = props.tradeValues) === null || _31 === void 0 ? void 0 : _31.issueId,
                    cutOff: ((_32 = props.tradeValues) === null || _32 === void 0 ? void 0 : _32.orderType) == "Retail" && props.tradeValues.cutOff
                        ? "Y"
                        : "N",
                    orderType: ((_33 = props.tradeValues) === null || _33 === void 0 ? void 0 : _33.orderType) == "Retail"
                        ? props.tradeValues.orderType
                        : "Non-Institutional",
                    exch: "NSE",
                    price: (_34 = props.tradeValues) === null || _34 === void 0 ? void 0 : _34.amount,
                    buyQty: (_35 = props.tradeValues) === null || _35 === void 0 ? void 0 : _35.quantity,
                },
            };
            di.tocJourney.placeOfsTrade(payloadOFS);
        }
        else if (props.action === TOCBUYORSELL.SIP) {
            di.tocJourney.placeEsipTrade(payloadEsip);
            setSipsuccess(true);
        }
        else if (props.amoOrder &&
            (props.exchange == exchangesData.MCX ||
                props.exchange == exchangesData.NCDEX)) {
            payloadAMO.amoBody.prdCode =
                getProductValues(props === null || props === void 0 ? void 0 : props.buttonList, (_36 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _36 === void 0 ? void 0 : _36.PRODUCT) ||
                    ((_37 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _37 === void 0 ? void 0 : _37.PRODUCT);
            payloadAMO.amoBody.qty = (_38 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _38 === void 0 ? void 0 : _38.quantity;
            payloadAMO.amoBody.ordSrc = "TOC";
            payloadAMO.amoBody.locInd = "WEB";
            payloadAMO.amoBody.vlDt = "";
            payloadAMO.amoBody.empOrDependent = empOrDependent;
            payloadAMO.amoBody.dsQty = (_39 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _39 === void 0 ? void 0 : _39.disclosedQuantity;
            payloadAMO.amoBody.lmPrc = "";
            di.tocJourney.placeAMOTradeComm(payloadAMO);
        }
        else if (props.amoOrder &&
            !(props.exchange == exchangesData.MCX ||
                props.exchange == exchangesData.NCDEX)) {
            payloadAMO.amoBody.dscQty = (_40 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _40 === void 0 ? void 0 : _40.disclosedQuantity;
            di.tocJourney.placeAMOTrade(payloadAMO);
        }
        else if (props.exchange == exchangesData.MCX ||
            props.exchange == exchangesData.NCDEX) {
            payloadAMO.amoBody.dsQty = (_41 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _41 === void 0 ? void 0 : _41.disclosedQuantity;
            di.tocJourney.placeTradeComm(payloadCO);
        }
        else if (((_42 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _42 === void 0 ? void 0 : _42.PRODUCT) ===
            eqProducts.find(function (x) { return x.title === "BO"; }).title) {
            di.tocJourney.placeBracketTrade(payloadBO);
        }
        else {
            di.tocJourney.placeNormalTrade(payloadNormal);
        }
    };
    var modifyOrder = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        if (props.exchange === "OFS") {
            var payloadOFS = {
                userID: userID,
                body: {
                    issueId: (_a = props.tradeValues) === null || _a === void 0 ? void 0 : _a.issueId,
                    cutOff: ((_b = props.tradeValues) === null || _b === void 0 ? void 0 : _b.orderType) == "Retail" && props.tradeValues.cutOff
                        ? "Y"
                        : "N",
                    exch: EExchangeType.NSE,
                    price: (_c = props.tradeValues) === null || _c === void 0 ? void 0 : _c.amount,
                    buyQty: (_d = props.tradeValues) === null || _d === void 0 ? void 0 : _d.quantity,
                    nestOrderNumber: (_e = props.tradeValues) === null || _e === void 0 ? void 0 : _e.orderId,
                },
            };
            di.tocJourney.placeOfsModifyTrade(payloadOFS);
            return;
        }
        var payloadNormal = {
            userID: userID,
            isAmo: props.amoOrder,
            body: {
                trdSym: (_f = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _f === void 0 ? void 0 : _f.tradeSymbol,
                exc: props.exchange,
                action: props.action.toUpperCase(),
                sym: (_g = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _g === void 0 ? void 0 : _g.symbol,
                dur: (_h = props === null || props === void 0 ? void 0 : props.activeButton) === null || _h === void 0 ? void 0 : _h.VALIDITY,
                ordTyp: ((_j = props === null || props === void 0 ? void 0 : props.activeButton) === null || _j === void 0 ? void 0 : _j.ORDER) === "SL"
                    ? "STOP_LIMIT"
                    : (_k = props === null || props === void 0 ? void 0 : props.activeButton) === null || _k === void 0 ? void 0 : _k.ORDER,
                qty: (_l = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _l === void 0 ? void 0 : _l.quantity,
                // dscQty: props?.tradeValues?.disclosedQuantity,
                lmPrc: (_m = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _m === void 0 ? void 0 : _m.limitPrice,
                trgPrc: (_o = props.tradeValues) === null || _o === void 0 ? void 0 : _o.triggerPrice,
                prdCode: getProductValues(props === null || props === void 0 ? void 0 : props.buttonList, (_p = props === null || props === void 0 ? void 0 : props.activeButton) === null || _p === void 0 ? void 0 : _p.PRODUCT) ||
                    ((_q = props === null || props === void 0 ? void 0 : props.activeButton) === null || _q === void 0 ? void 0 : _q.PRODUCT),
                ordSrc: "TOC",
                nstOID: (_r = props === null || props === void 0 ? void 0 : props.modifyData) === null || _r === void 0 ? void 0 : _r.orderId,
                flQty: (_s = props === null || props === void 0 ? void 0 : props.modifyData) === null || _s === void 0 ? void 0 : _s.flQty,
                empOrDependent: empOrDependent,
                curQty: (_t = props === null || props === void 0 ? void 0 : props.modifyData) === null || _t === void 0 ? void 0 : _t.ntQty,
            },
        };
        if (props.exchange == exchangesData.MCX ||
            props.exchange == exchangesData.NCDEX) {
            payloadNormal.body.dsQty = (_u = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _u === void 0 ? void 0 : _u.disclosedQuantity;
            di.tocJourney
                .coModifyOrder(payloadNormal)
                .then(function (data) {
                (device === null || device === void 0 ? void 0 : device.isDesktop)
                    ? props === null || props === void 0 ? void 0 : props.afterModifyAction(data === null || data === void 0 ? void 0 : data.msg)
                    : navigate("".concat(props === null || props === void 0 ? void 0 : props.afterMarketRedirect), {
                        state: { msg: data === null || data === void 0 ? void 0 : data.msg },
                    });
            })
                .catch(function (error) {
                (device === null || device === void 0 ? void 0 : device.isDesktop)
                    ? props === null || props === void 0 ? void 0 : props.afterModifyAction(error.getErrorMessageOrErrMsg())
                    : navigate("".concat(props === null || props === void 0 ? void 0 : props.afterMarketRedirect), {
                        state: { msg: error.getErrorMessageOrErrMsg() },
                    });
            });
        }
        else {
            payloadNormal.body.dscQty = (_v = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _v === void 0 ? void 0 : _v.disclosedQuantity;
            di.tocJourney
                .modifyOrder(payloadNormal)
                .then(function (data) {
                (device === null || device === void 0 ? void 0 : device.isDesktop)
                    ? props === null || props === void 0 ? void 0 : props.afterModifyAction(data === null || data === void 0 ? void 0 : data.msg)
                    : navigate("".concat(props === null || props === void 0 ? void 0 : props.afterMarketRedirect), {
                        state: { msg: data === null || data === void 0 ? void 0 : data.msg },
                    });
                // : navigate(`${props?.afterMarketRedirect}`, {
                //     replace: true,
                //     state: { msg: data?.msg },
                //   });
            })
                .catch(function (error) {
                (device === null || device === void 0 ? void 0 : device.isDesktop)
                    ? props === null || props === void 0 ? void 0 : props.afterModifyAction(error.getErrorMessageOrErrMsg())
                    : navigate("".concat(props === null || props === void 0 ? void 0 : props.afterMarketRedirect), {
                        state: { msg: error.getErrorMessageOrErrMsg() },
                    });
            });
        }
    };
    var SIPOROther = function () {
        var _a, _b;
        if (!placeNormalTradeLoader &&
            !placeNormalTradeError.isOpen &&
            placeNormalTrade.success) {
            if ((props.action === TOCBUYORSELL.SIP && sipsuccess) ||
                props.exchange === "OFS") {
                setScreenState(ITOCScreenStateEnum.SUCCESS_ORDER);
            }
            else if (((_a = placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.orderList) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                (placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.failedShrs) === "") {
                setScreenState(ITOCScreenStateEnum.SPLIT_ORDER);
            }
            else if (((_b = placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.orderList) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                (placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.failedShrs) !== "") {
                setScreenState(ITOCScreenStateEnum.SPLIT_ORDER_PARTIAL);
            }
            else {
                var payload = {
                    userID: userID,
                    orderID: placeNormalTrade.orderID,
                    isComm: props.exchange == exchangesData.MCX ||
                        props.exchange == exchangesData.NCDEX,
                };
                di.tocJourney.orderDetails(payload);
            }
        }
        else if (!placeNormalTradeLoader && placeNormalTradeError.isOpen) {
            setScreenState(ITOCScreenStateEnum.REJECTED_ORDER);
        }
    };
    var goToPositions = function () {
        if (location.pathname === reportsRoutePaths[EReportRoutes.positions])
            props.closeToc();
        else
            navigate(reportsRoutePaths[EReportRoutes.positions]);
        // window.open(config.oldWebUrl + "?ottype=my-positions", "_blank");
    };
    useEffect(function () {
        return function () {
            // Anything in here is fired on component unmount.
            di.tocJourney.flushPlaceOrderError();
            di.tocJourney.flushPlaceOrderData();
        };
    }, []);
    useEffect(function () {
        var _a, _b, _c;
        if (!placeNormalTradeError.isOpen &&
            ((_a = placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.orderList) === null || _a === void 0 ? void 0 : _a.length) == 0) {
            if (!orderDetailsLoader &&
                !orderDetailsError.isOpen &&
                ((_b = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.orderDetails) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                (checkMarginData === null || checkMarginData === void 0 ? void 0 : checkMarginData.insufficientFund)) {
                setScreenState(ITOCScreenStateEnum.INSUFFICIENT_FUND);
            }
            else if (!orderDetailsLoader &&
                !orderDetailsError.isOpen &&
                ((_c = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.orderDetails) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                if ((props === null || props === void 0 ? void 0 : props.tocState) === OrderbookTocStateEnum.REORDER) {
                    (device === null || device === void 0 ? void 0 : device.isDesktop)
                        ? props === null || props === void 0 ? void 0 : props.afterModifyAction(placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.message)
                        : navigate("".concat(props === null || props === void 0 ? void 0 : props.afterMarketRedirect), {
                            state: { msg: placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.message },
                        });
                }
                else {
                    setScreenState(ITOCScreenStateEnum.SUCCESS_ORDER);
                }
            }
            else if (!orderDetailsLoader && (orderDetailsError === null || orderDetailsError === void 0 ? void 0 : orderDetailsError.isOpen)) {
                setScreenState(ITOCScreenStateEnum.REJECTED_ORDER);
            }
        }
    }, [orderDetailsLoader, orderDetailsError, orderDetails.orderDetails]);
    useEffect(function () {
        SIPOROther();
    }, [placeNormalTradeLoader, placeNormalTradeError, placeNormalTrade]);
    var screenHeader = function () {
        return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
            React.createElement(TocStockHeader, { children: isSuccessRes ? (React.createElement(StockQuote, { stockQuoteDetails: multiQuote, setChartIQ: function () {
                        setScreenState(ITOCScreenStateEnum.CHART_IQ);
                    } })) : (React.createElement(SingleHeadingText, { title: "Order Confirmation" })) }))) : ("")));
    };
    var screenHandler = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        switch (screenState) {
            case ITOCScreenStateEnum.CHART_IQ:
                return (React.createElement(ChartiqBtmDrawer, { symbol: ((_a = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.symbol) || "", instru: ((_b = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _b === void 0 ? void 0 : _b.asTyp) || "", disable: true, showCross: true, goBack: function () { return setScreenState(ITOCScreenStateEnum.ORDER_CONFIRM); } }));
            case ITOCScreenStateEnum.ORDER_CONFIRM:
                return (React.createElement(React.Fragment, null,
                    screenHeader(),
                    React.createElement(OrderConfirmation, { headingWithBackBtn: props.headingWithBackBtn ? props.headingWithBackBtn : true, viewAllbackLink: function () { return props.setConfirmOrder(false); }, stockName: (multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity)
                            ? (_c = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _c === void 0 ? void 0 : _c.displayName
                            : "", description: (multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity)
                            ? (_d = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _d === void 0 ? void 0 : _d.description
                            : "", change: (multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity)
                            ? (_e = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _e === void 0 ? void 0 : _e.change
                            : "", changePer: (multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity)
                            ? (_f = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _f === void 0 ? void 0 : _f.changePercentage
                            : "", ltp: (multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity)
                            ? (_g = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _g === void 0 ? void 0 : _g.lastTradedPrice
                            : "", orderBodyList: (props === null || props === void 0 ? void 0 : props.action) !== TOCBUYORSELL.SIP &&
                            checkMarginData &&
                            (checkMarginData.orderMargin || checkMarginData.availableCash)
                            ? __spreadArray(__spreadArray([], __read(props === null || props === void 0 ? void 0 : props.orderConfirmationList), false), [
                                {
                                    title: "Margin required",
                                    value: addCommasWithoutDecimal(checkMarginData === null || checkMarginData === void 0 ? void 0 : checkMarginData.orderMargin),
                                },
                                {
                                    title: "Available",
                                    value: addCommasWithoutDecimal(checkMarginData === null || checkMarginData === void 0 ? void 0 : checkMarginData.availableCash),
                                },
                            ], false) : __spreadArray([], __read(props === null || props === void 0 ? void 0 : props.orderConfirmationList), false), exchange: props === null || props === void 0 ? void 0 : props.exchange, quantity: (_h = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _h === void 0 ? void 0 : _h.quantity, validity: (_j = props === null || props === void 0 ? void 0 : props.activeButton) === null || _j === void 0 ? void 0 : _j.VALIDITY, activeButton: props === null || props === void 0 ? void 0 : props.activeButton, disclosedQty: props.action === TOCBUYORSELL.SIP
                            ? (_k = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _k === void 0 ? void 0 : _k.quantity
                            : (_l = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _l === void 0 ? void 0 : _l.disclosedQuantity, hideAdditionalDetails: props.hideAdditionalDetails, showPaymentNotification: props.showPaymentNotification, showMandate: props.showMandate, declarationMsg: props === null || props === void 0 ? void 0 : props.declarationMsg, parentClassName: (props === null || props === void 0 ? void 0 : props.parentClassName) ||
                            "".concat(pitrifCheck.expandedVisual && pitrifCheck.empOrDependent
                                ? "max-height-13rem"
                                : "", "\n              ").concat(pitrifCheck.empOrDependent && !pitrifCheck.expandedVisual
                                ? "max-height-10rem"
                                : ""), dpExpDt: (multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity)
                            ? (_m = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _m === void 0 ? void 0 : _m.dpExpDt
                            : "", dpInsTyp: (multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity)
                            ? (_o = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _o === void 0 ? void 0 : _o.dpInsTyp
                            : "" }),
                    React.createElement("div", { className: "bottom-contents" }, props.isConfirmationBtn ? (React.createElement(BuySellBtn, { refreshLabelTitle: "Sell", rightButton: {
                            btnTyp: "midnight-blue",
                            value: "Confirm",
                            className: "w-100",
                            onClick: function () { return props.setpaymentMethod(true); },
                        }, cancelAction: function () { return props.setConfirmOrder(false); } })) : (React.createElement(React.Fragment, null,
                        (props === null || props === void 0 ? void 0 : props.action) !== TOCBUYORSELL.SIP && (React.createElement(MarginShortFunds, { title: "", showZero: true })),
                        React.createElement(PIT_IRF, { notRequired: (props === null || props === void 0 ? void 0 : props.pitNotRequired) ||
                                (props === null || props === void 0 ? void 0 : props.action) === TOCBUYORSELL.SIP, setPitrifCheck: setPitrifCheck }),
                        React.createElement(BuySellBtn, { refreshLabelTitle: "Sell", rightButton: {
                                btnTyp: "".concat(props.action === TOCBUYORSELL.BUY ||
                                    props.action === TOCBUYORSELL.SIP
                                    ? "green-btn"
                                    : "red-btn"),
                                value: (React.createElement(React.Fragment, null, placeNormalTradeLoader ? (React.createElement(ThreeDotLoader, null)) : ("Confirm ".concat(checkTocState(props === null || props === void 0 ? void 0 : props.tocState, OrderbookTocStateEnum.MODIFY)
                                    ? "Modify"
                                    : props.action === TOCBUYORSELL.BUY ||
                                        props.action === TOCBUYORSELL.SIP
                                        ? "Buy"
                                        : "Sell")))),
                                className: "w-100",
                                onClick: function () {
                                    if (checkTocState(props === null || props === void 0 ? void 0 : props.tocState, OrderbookTocStateEnum.MODIFY)) {
                                        modifyOrder();
                                    }
                                    else {
                                        placeOrder();
                                    }
                                },
                                disabled: placeNormalTradeLoader,
                            }, cancelAction: function () {
                                onCompUnmount();
                            } }))))));
            case ITOCScreenStateEnum.INSUFFICIENT_FUND:
                return (React.createElement(React.Fragment, null,
                    screenHeader(),
                    React.createElement("div", { className: "bg_white add-scroll-parentclass" },
                        React.createElement(OrderMsg, { title: "Order Rejected", status: false, goBack: true, goBackFunction: props === null || props === void 0 ? void 0 : props.closeToc, state: screenState, tradeValue: props === null || props === void 0 ? void 0 : props.action, multiQuote: multiQuote, sortFunds: checkMarginData === null || checkMarginData === void 0 ? void 0 : checkMarginData.insufficientFund, btnvalueleft: {
                                value: "Add Funds",
                                btnTyp: "midnight-blue-border",
                                className: "w-100 px-2",
                                onClick: function () {
                                    (device === null || device === void 0 ? void 0 : device.isDesktop)
                                        ? openFundTransferTab()
                                        : navigate("/fund-transfer", {
                                            state: { backRoute: window.location.href },
                                        });
                                },
                            }, btnvalueright: {
                                value: "Re-Order",
                                btnTyp: "midnight-blue",
                                className: "w-100 px-2",
                                onClick: function () {
                                    onCompUnmount();
                                },
                            }, parentbuttonClass: "btn-class-btntype bottom-contents pb-2" }))));
            case ITOCScreenStateEnum.SPLIT_ORDER:
                return (React.createElement(React.Fragment, null,
                    screenHeader(),
                    React.createElement("div", { className: "bg_white add-scroll-parentclass " },
                        React.createElement(OrderMsg, { title: "Done!", state: screenState, status: true, tradeValue: props === null || props === void 0 ? void 0 : props.action, multiQuote: multiQuote, orderList: placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.orderList, btnvalueleft: {
                                value: "Go to Positions",
                                btnTyp: "midnight-blue-border",
                                className: "w-100 px-2",
                                onClick: goToPositions,
                            }, btnvalueright: {
                                value: "Order Status",
                                btnTyp: "midnight-blue-border",
                                className: "w-100 px-2",
                                onClick: function (e) {
                                    var route = "";
                                    if (props.action === TOCBUYORSELL.SIP) {
                                        route = "".concat(config.rootUrl, "orderbook/").concat(EorderBookButtonsList.EQ, "/esip");
                                    }
                                    else if (props.exchange == exchangesData.MCX ||
                                        props.exchange == exchangesData.NCDEX) {
                                        route = "".concat(config.rootUrl, "orderbook/").concat(EorderBookButtonsList.COMOD);
                                    }
                                    else if (props.exchange === "OFS") {
                                        route = "".concat(config.rootUrl, "orderbook/ofs");
                                    }
                                    else {
                                        route = "".concat(config.rootUrl, "orderbook/").concat(EorderBookButtonsList.EQ);
                                    }
                                    if (props === null || props === void 0 ? void 0 : props.WatchListInstanceFlag) {
                                        window.open(route, "_blank");
                                    }
                                    else {
                                        window.location.href = route;
                                    }
                                },
                            }, btnvalueback: {
                                value: "Go Back",
                                btnTyp: "vivid-green-border",
                                className: "w-100 px-2 pt-2 pb-2",
                                onClick: function () {
                                    props === null || props === void 0 ? void 0 : props.closeToc();
                                },
                            }, parentbuttonClass: "btn-class-btntype bottom-contents pb-2" }))));
            case ITOCScreenStateEnum.SPLIT_ORDER_PARTIAL:
                return (React.createElement(React.Fragment, null,
                    screenHeader(),
                    React.createElement("div", { className: "bg_white common-drawer-scroll" },
                        React.createElement(OrderMsg, { title: "Done!", state: screenState, status: true, tradeValue: props === null || props === void 0 ? void 0 : props.action, multiQuote: multiQuote, orderList: placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.orderList, btnvalueleft: {
                                value: "Go to Positions",
                                btnTyp: "midnight-blue-border",
                                className: "w-100 px-2",
                                onClick: goToPositions,
                            }, btnvalueright: {
                                value: "Order Status",
                                btnTyp: "midnight-blue-border",
                                className: "w-100 px-2",
                                onClick: function () {
                                    var route = "";
                                    if (props.action === TOCBUYORSELL.SIP) {
                                        route = "".concat(config.rootUrl, "orderbook/").concat(EorderBookButtonsList.EQ, "/esip");
                                    }
                                    else if (props.exchange == exchangesData.MCX ||
                                        props.exchange == exchangesData.NCDEX) {
                                        route = "".concat(config.rootUrl, "orderbook/").concat(EorderBookButtonsList.COMOD);
                                    }
                                    else {
                                        route = "".concat(config.rootUrl, "orderbook/").concat(EorderBookButtonsList.EQ);
                                    }
                                    if (props === null || props === void 0 ? void 0 : props.WatchListInstanceFlag) {
                                        window.open(route, "_blank");
                                    }
                                    else {
                                        window.location.href = route;
                                    }
                                },
                            }, btnvalueback: {
                                value: "Go Back",
                                btnTyp: "vivid-green-border",
                                className: "w-100 px-2 pt-2 pb-2",
                                onClick: function () {
                                    props === null || props === void 0 ? void 0 : props.closeToc();
                                },
                            }, parentbuttonClass: "btn-class-btntype bottom-contents pb-2", failedShrs: (placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.failedShrs)
                                ? placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.failedShrs
                                : "", orderCalculations: props === null || props === void 0 ? void 0 : props.orderCalculations, placeReOrder: placeReOrder }))));
            case ITOCScreenStateEnum.SUCCESS_ORDER:
                return (React.createElement(React.Fragment, null,
                    screenHeader(),
                    React.createElement("div", { className: "bg_white  add-scroll-parentclass " },
                        React.createElement(OrderMsg, { title: "Order Received", state: screenState, status: true, tradeValue: props === null || props === void 0 ? void 0 : props.action, multiQuote: multiQuote, btnvalueleft: {
                                value: "Go to Positions",
                                btnTyp: "midnight-blue-border",
                                className: "w-100 px-2",
                                onClick: goToPositions,
                            }, btnvalueright: {
                                value: "Order Status",
                                btnTyp: "midnight-blue-border",
                                className: "w-100 px-2",
                                onClick: function () {
                                    var route = "";
                                    if (props.action === TOCBUYORSELL.SIP) {
                                        route = "".concat(config.rootUrl, "orderbook/").concat(EorderBookButtonsList.EQ, "/esip");
                                    }
                                    else if (props.exchange == exchangesData.MCX ||
                                        props.exchange == exchangesData.NCDEX) {
                                        route = "".concat(config.rootUrl, "orderbook/").concat(EorderBookButtonsList.COMOD);
                                    }
                                    else if (props.exchange === "OFS") {
                                        route = "".concat(config.rootUrl, "orderbook/ofs");
                                    }
                                    else {
                                        route = "".concat(config.rootUrl, "orderbook/").concat(EorderBookButtonsList.EQ, "/").concat(EOrderBookTabs.OPENORDER, "/").concat(placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.orderID);
                                    }
                                    if (props === null || props === void 0 ? void 0 : props.WatchListInstanceFlag) {
                                        window.open(route, "_blank");
                                    }
                                    else {
                                        window.location.href = route;
                                    }
                                },
                            }, btnvalueback: {
                                value: "Go Back",
                                btnTyp: "vivid-green-border",
                                className: "w-100 px-2 pt-2 pb-2",
                                onClick: function () {
                                    props === null || props === void 0 ? void 0 : props.closeToc();
                                },
                            }, parentbuttonClass: "btn-class-btntype bottom-contents pb-2" }))));
            case ITOCScreenStateEnum.REJECTED_ORDER:
                return (React.createElement(React.Fragment, null,
                    screenHeader(),
                    React.createElement("div", { className: "bg_white add-scroll-parentclass" },
                        React.createElement(OrderMsg, { title: "Order Failed", state: screenState, status: false, goBack: true, goBackFunction: props === null || props === void 0 ? void 0 : props.closeToc, tradeValue: props === null || props === void 0 ? void 0 : props.action, multiQuote: multiQuote, btnvalueleft: {
                                value: "Go to Orderbook",
                                btnTyp: "midnight-blue-border",
                                className: "w-100 ms-2 px-0",
                                onClick: function () {
                                    var route = "";
                                    if (props.action === TOCBUYORSELL.SIP) {
                                        route = "".concat(config.rootUrl, "orderbook/").concat(EorderBookButtonsList.EQ, "/esip");
                                    }
                                    else if (props.exchange == exchangesData.MCX ||
                                        props.exchange == exchangesData.NCDEX) {
                                        route = "".concat(config.rootUrl, "orderbook/").concat(EorderBookButtonsList.COMOD, "/").concat(CommodityOrderBookTabs.CLOSEORDER);
                                    }
                                    else if (props.exchange === "OFS") {
                                        route = "".concat(config.rootUrl, "orderbook/ofs");
                                    }
                                    else {
                                        route = "".concat(config.rootUrl, "orderbook/").concat(EorderBookButtonsList.EQ, "/").concat(EOrderBookTabs.CLOSEORDER);
                                    }
                                    if (props === null || props === void 0 ? void 0 : props.WatchListInstanceFlag) {
                                        window.open(route, "_blank");
                                    }
                                    else {
                                        window.location.href = route;
                                    }
                                },
                            }, hideRightBtn: props.exchange === "OFS" ? true : false, btnvalueright: {
                                value: "Re-Order",
                                btnTyp: "midnight-blue",
                                className: "w-100 ms-2 px-0",
                                onClick: function () {
                                    onCompUnmount();
                                },
                            }, parentbuttonClass: "btn-class-btntype bottom-contents pb-2" }))));
        }
    };
    return (React.createElement(React.Fragment, null, orderDetailsLoader ? React.createElement(Common_Shimmer, null) : screenHandler()));
};
export default OrderConfirmationMain;
